import React from "react";

const LogoutIcon = () => {
  return <span className="prof-icon icon-profile_signout" />;
};

export default LogoutIcon;
